import type { ReactNode } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import ScrollToTop from "@/components/feature/ScrollToTop";

interface SiteLayoutProps {
  children: ReactNode;
  overlay?: boolean;
}

export default function SiteLayout({ children, overlay = false }: SiteLayoutProps) {
  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <ScrollToTop />
      <SiteHeader overlay={overlay} />
      <main className={`w-full flex-1 ${overlay ? "" : "pt-16 md:pt-20"}`}>{children}</main>
      <SiteFooter />
    </div>
  );
}